<template>
    <div class="join-view">
        <van-form @submit="onSubmit" class="form-box">
            <van-cell-group inset>
                <van-field
                    required
                    v-model="employee_name"
                    name="employee_name"
                    label="账号"
                    placeholder="账号"
                    :rules="[{ required: true, message: '请输入账号' }]"
                />

                <van-field
                    required
                    v-model="employee_pwd"
                    name="employee_pwd"
                    type="password"
                    label="密码"
                    placeholder="密码"
                    :rules="[{ required: true, message: '请输入密码' }]"
                />

                <van-field
                    required
                    v-model="command"
                    name="command"
                    label="口令"
                    placeholder="口令"
                    :rules="[{ required: true, message: '请输入口令' }]"
                />

            </van-cell-group>
            <div style="margin: 16px;">
                <van-button round block v-model:disabled="disabled" type="primary" native-type="submit">
                    提交
                </van-button>
            </div>
        </van-form>

    </div>
</template>
<script>

import ayzAjax from "@/plugins/axios";
import {showFailToast, showSuccessToast} from "vant";

export default {
    name: "JoinView",
    data: function () {
        return {
            show:false,
            employee_name: '',
            employee_pwd: '',
            command: '',
            isSubmit:false,
            disabled:false,
            chatLoginInfo:null,
        }
    },
    created() {
        this.chatLoginInfo = JSON.parse(localStorage.getItem('chatLoginInfo'));
        if (this.chatLoginInfo !== null){
            this.$router.push({ path: '/chat/list'});
        }
        console.log(this.chatLoginInfo);
    },
    methods: {
        onSubmit(fromData){
            if (this.isSubmit === true) {
                return false;
            }
            try {
                ayzAjax.post('/chat/account_login',fromData).then((response) => {
                    if(response.data.code !== 200){
                        showFailToast('提交失败,请稍后再试')
                        return false;
                    }
                    showSuccessToast('登录成功');
                    this.isSubmit = true;
                    this.disabled = true;
                    localStorage.setItem('chatLoginInfo', JSON.stringify(response.data.data));
                    this.chatLoginInfo = JSON.parse(localStorage.getItem('chatLoginInfo'));
                    this.$router.push({ path: '/chat/list'});
                    console.log(this.chatLoginInfo);
                })
            }catch(err) {
                console.log(err);
                showFailToast('网络错误,请稍后再试')
            }
        },

    }
}
</script>

<style scoped lang="scss" >
.join-view{
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    background: #F7F8FA;
    padding-top: 140px;
    max-width: 500px;
}
.form-box{
    width: 100%;
}
</style>

